
import error from './Error/Error.jsx'
import edited from './edited.jsx'
import close from './close-icon/CloseIcon.jsx'

export const ErrorIcon = error
export const EditedIcon = edited
export const CloseIcon = close
